import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { login, resetLoginForm } from 'actions/authActions';
import SigninForm from './signinForm';
import { hasFeaturedPrograms } from 'services/programs'

@connect(
  state => ({auth: state.auth}),
  { login, resetLoginForm }
)
export default class Signin extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    login: PropTypes.func.isRequired,
    resetLoginForm: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
  };

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  componentWillMount () {
    this.props.resetLoginForm({
      email: this.props.location.query.email
    });
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.auth.loggedIn) {
      if (nextProps.location.state && nextProps.location.state.next) {
        nextProps.history.replaceState(
          { next: null },
          nextProps.location.state.next
        );
      } else if (hasFeaturedPrograms()) {
        nextProps.history.replaceState({ next: null }, '/programs');
      } else {
        nextProps.history.replaceState({ next: null }, '/')
      }
    }
  }

  handleSubmit (data) {
    return this.props.login(data);
  }

  render () {
    return <SigninForm onSubmit={::this.handleSubmit} />;
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/signin.jsx